import { Component, Input, OnInit } from '@angular/core'
import { Answer } from 'src/app/models/Reports'

@Component({
	selector: 'app-photo-records',
	templateUrl: './photo-records.component.html'
})
export class PhotoRecordsComponent implements OnInit {
		@Input() public treeNotFoundMedia: Array<string> = []
		@Input() public answers: Array<Answer> = []
	@Input() public notTitle: boolean = false

		public ngOnInit() {
				this.answers = this.answers.filter(answer => answer.url)
		}

		public isTreeNotFoundMedia(): boolean {
				return this.treeNotFoundMedia.length > 0
		}
}
